import { render, staticRenderFns } from "./domicilios.vue?vue&type=template&id=0d8bf46e&"
import script from "./domicilios.vue?vue&type=script&lang=js&"
export * from "./domicilios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports